<template>
    <h2>Session End</h2>
</template>

<script>
    import firebase from '../Firebase'
    export default {
        name: "end",
        created(){
            firebase.auth().signOut().then( result => {
                console.log('signed out ' + result);
                window.location.href = "";
            })
        }
    }
</script>

<style scoped>

</style>